export default __webpack_public_path__ + "static/preethi-bc48dc25df1a7283f3d0bb5ecaf32056.jpg";